<template>
  <v-text-field v-bind:value="cellValue" v-bind:id="ctrlId" prefix="$" single-line readonly height="24"></v-text-field>
</template>

<script>
// import Vue from 'vue';
// import { utilityService } from '../../services/utilityService';
import { stringToArray } from 'ag-grid-community';
import { answerService } from '../../services/answerService';
import cellErrorHighlightMixin from './mixins/cellErrorHighlightMixin.js';

export default {
	name: 'ComputationCell',
	mixins: [cellErrorHighlightMixin],
  props: {
    id: String,
    name: String,
		index: Number,
    op: String,
    fields: Array,
    value: Number,
		subHeader: String,
    disabled: Boolean,
		rowLabel: String
  },
  data: () => ({
    theValue: undefined
  }),
  mounted () {
		this.theValue = (this.value != null) ? answerService.getAnswerValue(this.value) : answerService.getAnswerValue(null);
		if (this.theValue.value === Number.MIN_SAFE_INTEGER) {
			this.$emit('update:disable', true);
		}
		this.onValueChanged();
  },
  computed: {
    ctrlId: function () {
      return this.name + '_' + this.index + '_' + this.id;
    },
    cellValue: function () {
      return !this.theValue ? '' : this.theValue.strValue;
    }
  },
  watch: {
    value: function () {
      debugger;
      this.theValue.value = this.value;
			this.onValueChanged();
		},
		disabled: function (newVal, oldVal) {
      debugger;
      if (newVal === true) {
        if (this.theValue) {
          this.theValue.value = Number.MIN_SAFE_INTEGER;
          this.onValueChanged();
        }
      } else {
        this.theValue.value = 0;
        this.onValueChanged();
			}

			this.onValueChanged();
    }
  },
  methods: {
    onValueChanged: function () {
      debugger;
      this.$emit('update', {
        answerId: this.name,
        index: this.index,
        value: this.theValue.value,
				subHeader: this.subHeader
      });
    }
  }
};
</script>

<style scoped>
.row-header {
  font-weight: bold;
  color: #13314f;
}
.v-text-field >>> input {
  text-align: right;
  padding: 3px;
}
</style>
